import { withStyles } from "@material-ui/core/styles";
import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import {
  Button,
  Grid,
  FormControlLabel,
  Checkbox,
  MenuItem,
} from "@material-ui/core";

import { isJsonString, sortPackageList } from "../../utils/setting";
import { styles } from "./styles";
import Header from "../../partials/header";
import Loading from "../loading";
import InputFormat from "../../partials/inputForm";
import LabelForm from "../../partials/labelForm";
import CountryCode from "../countryCode";
const typeArray = ["VND", "USD"];
class SettingSystem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      setting: {
        paymentMethod: [],
        currencyCode: "VND",
        // signSeparateMoney: ",",
        // moneyAPoint: 0,
        tax: 0.1,
        defaultCountryCode: "+84",
      },
      packageList: [],
    };
  }
  async componentDidMount() {
    this.loading.startLoading();
    await this.props.getSettings();
    this.getListPackage();
    this.setState({ setting: this.props.setting });
    this.loading.stopLoading();
  }
  getListPackage = async () => {
    let check = await this.props.getListPackage();
    if (check.code === 1) {
      this.setState({
        packageList: sortPackageList(check.data),
      });
    }
  };
  componentWillReceiveProps(nextProps) {
    if (this.props.setting !== nextProps.setting) {
      this.setState({ setting: nextProps.setting });
    }
  }
  handleChangeTypePayment = (event) => {
    let { setting = {} } = this.state;
    if (isJsonString(setting.paymentMethod)) {
      setting.paymentMethod = JSON.parse(setting.paymentMethod);
    }
    setting.paymentMethod = setting.paymentMethod.includes(event.target.name)
      ? setting.paymentMethod.filter((i) => i !== event.target.name)
      : [...setting.paymentMethod, event.target.name]; // add item
    this.setState({ setting });
  };
  handleSubmit = async () => {
    this.loading.startLoading();
    let { setting = {} } = this.state;
    setting.paymentMethod = JSON.stringify(setting.paymentMethod);
    await this.props.updateSettings({ data: setting });
    this.loading.stopLoading();
  };
  handleChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    let { setting = {} } = this.state;
    setting[name] = value;
    this.setState({
      setting,
    });
  };
  handleCountryCode = (name, value) => {
    let { setting = {} } = this.state;
    setting.defaultCountryCode = value;
    this.setState({
      setting,
    });
  };
  render() {
    const { classes, t } = this.props;
    let { setting = {}, packageList } = this.state;
    if (isJsonString(setting.paymentMethod)) {
      setting.paymentMethod = JSON.parse(setting.paymentMethod);
    }
    return (
      <React.Fragment className={classes.root}>
        <Loading onRef={(id) => (this.loading = id)} />
        <Header
          session={t("sidebar_superadmin")}
          title={t("sidebar_setting_system")}
        />
        <div className={classes.root}>
          <div className={classes.container}>
            <Grid container spacing={3} className={classes.group}>
              <Grid item xs={12} ms={12} md={12}>
                <LabelForm
                  label={t(
                    "service_ownerspa_servicedetail_service_setting_payment_type"
                  )}
                />
                <Grid container spacing={0} className={classes.group}>
                  <Grid item xs={12} ms={12} md={12}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={
                            setting.paymentMethod &&
                            setting.paymentMethod.indexOf("vietNamPayment") > -1
                              ? true
                              : false
                          }
                          name="vietNamPayment"
                          onChange={this.handleChangeTypePayment}
                        />
                      }
                      // className={classes.label}
                      label={`${t(
                        "service_ownerspa_servicedetail_service_setting_credit_card"
                      )} (VietNamPayment)`}
                    />
                  </Grid>
                  <Grid item xs={12} ms={12} md={12}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={
                            setting.paymentMethod &&
                            (setting.paymentMethod.indexOf("stripe") > -1
                              ? true
                              : false)
                          }
                          name="stripe"
                          onChange={this.handleChangeTypePayment}
                        />
                      }
                      // className={classes.label}
                      label={`${t(
                        "service_ownerspa_servicedetail_service_setting_international_card"
                      )} (Stripe)`}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} ms={12} md={12}>
                <InputFormat
                  select
                  label={t(
                    "service_ownerspa_servicedetail_service_currrency_code"
                  )}
                  value={setting.currencyCode}
                  onChange={this.handleChange}
                  name="currencyCode"
                  margin="normal"
                  variant="outlined"
                >
                  {typeArray.map((type, index) => {
                    return (
                      <MenuItem key={index} value={type}>
                        {t(type)}
                      </MenuItem>
                    );
                  })}
                </InputFormat>
              </Grid>
              <Grid item xs={12} ms={12} md={12}>
                {/* <LabelForm label={t('service_ownerspa_servicedetail_service_tax')}/> */}
                <InputFormat
                  label={t("service_ownerspa_servicedetail_service_tax")}
                  margin="normal"
                  name="tax"
                  value={setting.tax}
                  onChange={this.handleChange}
                />
              </Grid>
              <Grid item xs={12} ms={12} md={12}>
                <CountryCode
                  margin="normal"
                  code={setting.defaultCountryCode}
                  handleCountryCode={this.handleCountryCode}
                />
              </Grid>

              <Grid item xs={12} ms={12} md={12}>
                {/* <LabelForm label={t("Default package")} /> */}
                <InputFormat
                  select
                  label={t("Default package")}
                  value={setting.defaultPackage}
                  onChange={this.handleChange}
                  name="defaultPackage"
                  margin="normal"
                  variant="outlined"
                >
                  {packageList.map((type, index) => {
                    return (
                      <MenuItem key={index} value={type.packageCode}>
                        {t(type.packageName)}
                      </MenuItem>
                    );
                  })}
                </InputFormat>
              </Grid>
            </Grid>
            <Grid container spacing={3}>
              <Grid item xs={12} ms={12} md={12}>
                <Button
                  onClick={this.handleSubmit}
                  color="primary"
                  size="large"
                  variant="contained"
                  component="span"
                  className={classes.button}
                >
                  {" "}
                  {t("service_ownerspa_servicedetail_update")}{" "}
                </Button>
              </Grid>
            </Grid>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapState = (state) => ({
  setting: state.setting.setting,
});

const mapDispatch = (dispatch) => ({
  getListPackage: dispatch.packages.getListPackage,
  getSettings: dispatch.setting.getSettings,
  updateSettings: dispatch.setting.updateSettings,
});
export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(
    withStyles(styles, { withTheme: true })(SettingSystem)
  )
);
